import React from "react";
import AdminAccountsPage from "./admin-accounts-page";

class AdminAccountsPageController extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            currentPage: 0,
            showedItemsCount: 10,
            sortBy: 'CREATED_AT',
            sortDirection: 'DESC',
            status: "ACTIVE",
            search: null,
        }
    }

    setSortByStatus = (status) => {
        this.setState({
            status: status,
            isUpdated: true
        })
        this.getAccounts(null, null, null, null, status);
    }

    setSort = (sort, sortDirection) => {
        this.setState({
            sortBy: sort,
            sortDirection: sortDirection
        })
        this.getAccounts(null, null, sort, sortDirection);
    }

    setSearch = (search) => {
        this.setState({
            search: search
        })
    }

    search = (searchText) => {
        this.setState({
            search: searchText
        })
        this.getAccounts(null, null, null, null, null, searchText);
    }

    getAccounts = (currentPage, showedItemsCount, sortBy, order, status, search=null) => {
        let page = currentPage && !isNaN(currentPage) ? currentPage : this.state.currentPage;
        let count = showedItemsCount ? showedItemsCount : this.state.showedItemsCount;
        let sort = sortBy ? sortBy : this.state.sortBy;
        let sortDirection = order ? order : this.state.sortDirection;
        let accountStatus = status ? status : this.state.status;
        let searchText = search !== null ? search : this.state.search;

        this.props.getAccounts(this.props.isSuperadmin, page, count, sort, sortDirection, accountStatus, searchText)
    }

    componentDidMount(){
        this.props.setCompanyId(null)
        this.getAccounts(0, 10);
    }

    componentDidUpdate(){
        if(this.props.currentPage !== this.state.currentPage || this.props.showedItemsCount !== this.state.showedItemsCount){
            
            if(this.props.currentPage >= (this.props.itemsCount / this.props.showedItemsCount)){
                this.props.setCurrentPage(0)
                
                //this.getAccounts(0, this.props.showedItemsCount);
            }
            this.setState({
                currentPage: this.props.currentPage,
                showedItemsCount: this.props.showedItemsCount
            })
            this.getAccounts(this.props.currentPage, this.props.showedItemsCount);
        }
        if(Number(this.props.adminAccountsCount) && this.props.itemsCount !== this.props.adminAccountsCount){
            this.props.setItemsCount(this.props.adminAccountsCount)
        }
    }

    render(){
        return (
            <AdminAccountsPage 
                                setSort={this.setSort} 
                                sortBy={this.state.sortBy} 
                                sortDirection={this.state.sortDirection} 
                                status={this.state.status} 
                                setSortByStatus={this.setSortByStatus}
                                search={this.search}
                                searchText={this.state.search}
                            />
        )
    }

    componentWillUnmount(){
        this.props.setAccountId(null)
        this.props.setTopicId(null)
        /*this.props.setItemsCount(null)
        this.props.setCurrentPage(0)
        this.props.setShowedItemsCount(10)*/

        this.props.setToDefaultPaginator();
    }
}

export default AdminAccountsPageController;